<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-clipboard-list"></i></span>DO 明細</h1>
    <h2>倉別：{{ DODetail.depotType }} / 出貨單號：{{ DODetail.shippingNum }}</h2>
    <p-steps [model]="flowStatuses" [activeIndex]="currentStatusIdx" styleClass="mb-4"></p-steps>
    <p-card>
        <p-table #dataTable class="datatable" [value]="moveOrders" [columns]="selectedColumns" [resizableColumns]="true" [reorderableColumns]="true" columnResizeMode="expand" rowExpandMode="single" dataKey="pdNo" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
            [autoLayout]="true" sortMode="multiple">
            <ng-template pTemplate="caption">
              <laas-table-column-toggle
                [optionsColumn]="columns"
                [dataTable]="dataTable">
              </laas-table-column-toggle>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width: 5%;"></th>
                    <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn>
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                <tr>
                    <td>
                        <span [pRowToggler]="rowData" (click)="rowToggleBtnClick($event, rowData, expanded)" style="cursor: pointer;"><i
                [class]="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i></span>
                    </td>
                    <td *ngFor="let col of columns">
                        <ng-container [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'moStatus'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:MOStatusOptions }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData>
                <tr>
                    <td [attr.colspan]="columns.length + 1">
                        <p>移轉工單明細 - {{ rowData.pdNo }}</p>
                        <div>
                            <p-table #detailDataTable class="datatable" [value]="rowData.moveOrderItems" [columns]="detailCols" [resizableColumns]="true" [reorderableColumns]="true" columnResizeMode="expand" [scrollable]="true" [rows]="10" scrollHeight="15rem" [virtualScroll]="true">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns" pResizableColumn pReorderableColumn>
                                            {{col.header}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="detailCols">
                                    <tr>
                                        <td *ngFor="let col of detailCols">
                                            <ng-container [ngSwitch]="col.field">
                                                <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="detailCols.length" style="text-align: center;">
                                            {{ 'Common.Table.NoData' | translate }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="selectedColumns.length + 1" style="text-align: center;">
                        {{ 'Common.Table.NoData' | translate }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-card>
</div>
